import * as React from 'react';
import { ColumnType } from 'antd/es/table';
import { EllipsisSpan } from '../../EllipsisSpan';
import { getRange } from '../../../../../utils/utils';
import { getActualParameter } from '../modbusPoint/columns';
import { FilterModeDisplay } from '@/shared/const';
import { isNil } from 'lodash-es';

export const getColumns = (parameter: string[], alterMode?: boolean): ColumnType<any>[] => {
  const _parameter = getActualParameter(parameter);
  const columns: ColumnType<any>[] = [
    {
      title: '单位',
      fixed: 'left',
      dataIndex: 'physicalUnitGeneralName',
      ellipsis: { showTitle: true },
      render: (value: string) => (
        <EllipsisSpan value={value} defaultValue={alterMode ? '点击编辑操作修改' : undefined} />
      ),
    },
    {
      title: '采集点类型',
      dataIndex: 'hasProperty',
      ellipsis: { showTitle: true },
      render: (value: boolean) => <EllipsisSpan value={value ? '建模采集点' : '非建模采集点'} />,
    },
    {
      title: '是否可写',
      dataIndex: 'writable',
      ellipsis: { showTitle: true },
      render: (v: string) => (
        <EllipsisSpan value={typeof v === 'boolean' ? (v ? '是' : '否') : alterMode ? '点击编辑操作修改' : undefined} />
      ),
    },
    {
      title: '数据标识',
      dataIndex: 'dataId',
      ellipsis: { showTitle: true },
      render: (_: undefined, record) => <EllipsisSpan value="excel导入" />,
    },
    {
      title: '乘积系数k',
      dataIndex: 'k',
      ellipsis: { showTitle: true },
      render: (_: undefined, record) => <EllipsisSpan value="excel导入" />,
    },
    {
      title: '偏移系数b',
      dataIndex: 'b',
      ellipsis: { showTitle: true },
      render: (_: undefined, record) => <EllipsisSpan value="excel导入" />,
    },
    {
      title: '数据过滤模式',
      dataIndex: 'valueFilterMode',
      ellipsis: { showTitle: true },
      width: 120,
      render: (_: undefined, record) => {
        return (
          <EllipsisSpan
            value={
              !isNil(record.parameters?.valueFilterMode)
                ? FilterModeDisplay[record.parameters?.valueFilterMode as keyof typeof FilterModeDisplay]
                : alterMode
                ? '点击编辑过滤模式'
                : undefined
            }
          />
        );
      },
    },
    {
      title: '数值合理区间',
      dataIndex: 'dataRange',
      ellipsis: { showTitle: true },
      render: (_: undefined, record) => {
        const value = getRange(record.parameters?.valueFloor, record.parameters?.valueCeiling);
        return (
          <EllipsisSpan
            value={
              value !== '--'
                ? value
                : alterMode && record.parameters?.valueFilterMode !== 0
                ? '点击编辑操作修改'
                : undefined
            }
          />
        );
      },
    },
    {
      title: '云端增长值合理区间',
      dataIndex: 'cloudValueRange',
      ellipsis: { showTitle: true },
      width: 120,
      render: (_: undefined, record) => {
        const value = getRange(record.parameters?.cloudValueFloor, record.parameters?.cloudValueCeiling);
        return (
          <EllipsisSpan
            value={
              value !== '--'
                ? value
                : alterMode && record.parameters?.valueFilterMode !== 0
                ? '点击编辑操作修改'
                : undefined
            }
          />
        );
      },
    },
    {
      title: '云端异常数据过滤个数',
      dataIndex: 'cloudValueFilterCnt',
      ellipsis: { showTitle: true },
      width: 100,
      render: (_: number, record) => {
        return (
          <EllipsisSpan
            value={
              record.parameters.cloudValueFilterCnt
              ? record.parameters.cloudValueFilterCnt
                : alterMode && record.parameters?.valueFilterMode !== 0
                ? '点击编辑操作修改'
                : undefined
            }
          />
        );
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: { showTitle: true },
      render: (value: string) => <EllipsisSpan value={value} />,
    },
  ];

  return [
    {
      title: '数据属性/标识符',
      dataIndex: 'name',
      fixed: 'left',
      ellipsis: { showTitle: true },
      render: (_: undefined, record) => (
        <EllipsisSpan value={!!record.hasProperty ? record.dataPropertyName : record.identifier} />
      ),
    },
    ...(_parameter ? columns.filter(column => _parameter.includes(column.dataIndex as string)) : columns),
  ];
};
